import { Api, } from './Api';
// @ts-ignore
// eslint-disable-next-line functional/no-class
class CustomAPI extends Api {
}
export default CustomAPI;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ3VzdG9tQVBJLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2xpYi9DdXN0b21BUEkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUNMLEdBQUcsR0FNSixNQUFNLE9BQU8sQ0FBQztBQStRZixhQUFhO0FBQ2IsK0NBQStDO0FBQy9DLE1BQU0sU0FBVSxTQUFRLEdBQVk7Q0FBRztBQUV2QyxlQUFlLFNBQVMsQ0FBQyJ9